// Iterate manifestations and return the earliest publishedYear.
import type {ManifestationV4} from 'services/metadata/types';

export const getFirstManifestationPublishYear = (
  manifestations: ManifestationV4[],
): number | undefined =>
  manifestations.reduce<number | undefined>(
    (lowest, {publishedYear}) =>
      publishedYear != null && (lowest === undefined || publishedYear < lowest)
        ? publishedYear
        : lowest,
    undefined,
  );
